// ISKCONStorySection.js
import React from 'react';
import '../../css/HeaderSection.css'; // Custom CSS file

const HeaderSection = ({ title, desc }) => {
  return (
    <>
      <div className="iskcon-section text-white py-1 px-1">
        <div className="container mt-0">
          {/* <div className="title-accent mb-3"></div> */}
          <h2 className="fw-bold mb-3">{title}</h2>
          <p className="lead">
            {desc}
          </p>
        </div>
      </div>
    </>
  )
}


export default HeaderSection;
